module.exports = __webpack_public_path__ + "static/media/parkBackground.0231318e.png";